export const GLOBAL_ACTION_KEYS = [
  "displayMode",
  "accommodationResultsFormat",
  "accommodationSortingCriteria",
  "bookingAdvantagesPosition",
  "engineHighlightReelOrder",
  "showExtrasConfiguration",
  "priceCalendar",
  "enableLoyalty",
  "bookAndJoinType",
  "addMandatoryExtrasToInventoryRate",
  "showMandatoryExtras",
  "showEngineDiscount",
  "unavailableURL",
  "buttonRoundType",
  "tagRoundType",
  "bookingFormRoundType",
  "cardRoundType",
  "formRoundType",
  "paymentTickers",
  "promotionalcode",
  "messageCode",
  "tab",
  "segment",
] as const;

export type GlobalActionKey = typeof GLOBAL_ACTION_KEYS[number];

export type ActionValueType = "boolean" | "string" | "url" | "enum" | "stringList";

export const ACTION_VALUE_TYPES: Record<GlobalActionKey, ActionValueType> = {
  displayMode: "enum",
  accommodationResultsFormat: "enum",
  accommodationSortingCriteria: "enum",
  bookingAdvantagesPosition: "enum",
  engineHighlightReelOrder: "stringList",
  showExtrasConfiguration: "enum",
  priceCalendar: "enum",
  enableLoyalty: "boolean",
  bookAndJoinType: "enum",
  addMandatoryExtrasToInventoryRate: "boolean",
  showMandatoryExtras: "boolean",
  showEngineDiscount: "boolean",
  unavailableURL: "url",
  buttonRoundType: "enum",
  tagRoundType: "enum",
  bookingFormRoundType: "enum",
  cardRoundType: "enum",
  formRoundType: "enum",
  paymentTickers: "stringList",
  promotionalcode: "stringList",
  messageCode: "stringList",
  tab: "string",
  segment: "string",
};

export enum ActionKey {
  DISPLAY_MODE = "DISPLAY_MODE",
  ACCOMMODATION_RESULTS_FORMAT = "ACCOMMODATION_RESULTS_FORMAT",
  ACCOMMODATION_SORTING_CRITERIA = "ACCOMMODATION_SORTING_CRITERIA",
  BOOKING_ADVANTAGES_POSITION = "BOOKING_ADVANTAGES_POSITION",
  ENGINE_HIGHLIGHT_REEL_ORDER = "ENGINE_HIGHLIGHT_REEL_ORDER",
  SHOW_EXTRAS_CONFIGURATION = "SHOW_EXTRAS_CONFIGURATION",
  PRICE_CALENDAR = "PRICE_CALENDAR",
  ENABLE_LOYALTY = "ENABLE_LOYALTY",
  BOOK_AND_JOIN_TYPE = "BOOK_AND_JOIN_TYPE",
  ADD_MANDATORY_EXTRAS_TO_INVENTORY_RATE = "ADD_MANDATORY_EXTRAS_TO_INVENTORY_RATE",
  SHOW_MANDATORY_EXTRAS = "SHOW_MANDATORY_EXTRAS",
  SHOW_ENGINE_DISCOUNT = "SHOW_ENGINE_DISCOUNT",
  UNAVAILABLE_URL = "UNAVAILABLE_URL",
  BUTTON_ROUND_TYPE = "BUTTON_ROUND_TYPE",
  TAG_ROUND_TYPE = "TAG_ROUND_TYPE",
  BOOKING_FORM_ROUND_TYPE = "BOOKING_FORM_ROUND_TYPE",
  CARD_ROUND_TYPE = "CARD_ROUND_TYPE",
  FORM_ROUND_TYPE = "FORM_ROUND_TYPE",
  PAYMENT_TICKERS = "PAYMENT_TICKERS",
  PROMOTIONALCODE = "PROMOTIONALCODE",
  MESSAGE_CODE = "MESSAGE_CODE",
  TAB = "TAB",
  SEGMENT = "SEGMENT",
}

export const ActionKeyReverseMapping: Record<GlobalActionKey, ActionKey> = {
  displayMode: ActionKey.DISPLAY_MODE,
  accommodationResultsFormat: ActionKey.ACCOMMODATION_RESULTS_FORMAT,
  accommodationSortingCriteria: ActionKey.ACCOMMODATION_SORTING_CRITERIA,
  bookingAdvantagesPosition: ActionKey.BOOKING_ADVANTAGES_POSITION,
  engineHighlightReelOrder: ActionKey.ENGINE_HIGHLIGHT_REEL_ORDER,
  showExtrasConfiguration: ActionKey.SHOW_EXTRAS_CONFIGURATION,
  priceCalendar: ActionKey.PRICE_CALENDAR,
  enableLoyalty: ActionKey.ENABLE_LOYALTY,
  bookAndJoinType: ActionKey.BOOK_AND_JOIN_TYPE,
  addMandatoryExtrasToInventoryRate: ActionKey.ADD_MANDATORY_EXTRAS_TO_INVENTORY_RATE,
  showMandatoryExtras: ActionKey.SHOW_MANDATORY_EXTRAS,
  showEngineDiscount: ActionKey.SHOW_ENGINE_DISCOUNT,
  unavailableURL: ActionKey.UNAVAILABLE_URL,
  buttonRoundType: ActionKey.BUTTON_ROUND_TYPE,
  tagRoundType: ActionKey.TAG_ROUND_TYPE,
  bookingFormRoundType: ActionKey.BOOKING_FORM_ROUND_TYPE,
  cardRoundType: ActionKey.CARD_ROUND_TYPE,
  formRoundType: ActionKey.FORM_ROUND_TYPE,
  paymentTickers: ActionKey.PAYMENT_TICKERS,
  promotionalcode: ActionKey.PROMOTIONALCODE,
  messageCode: ActionKey.MESSAGE_CODE,
  tab: ActionKey.TAB,
  segment: ActionKey.SEGMENT,
};

export function isKnownActionKey(key: string): key is GlobalActionKey {
  return GLOBAL_ACTION_KEYS.includes(key as GlobalActionKey);
}

export function getAvailableActionKeys(usedKeys: string[]): GlobalActionKey[] {
  return GLOBAL_ACTION_KEYS.filter(key => !usedKeys.includes(key));
}
